import React from 'react';
import {render} from 'react-dom';
import Reboot from 'material-ui/Reboot';
import PropTypes from 'prop-types';
import AddIcon from 'material-ui-icons/Add';
import {
    Button, createMuiTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper,
    TextField,
    Typography
} from "material-ui";
import green from "material-ui/es/colors/green";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import blueGrey from "material-ui/es/colors/blueGrey";
import SubscriptionStore from "./stores/SubscriptionStore";
import SubscriptionActions from "./actions/SubscribeActions";

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 30,
    },
    paper: {
        padding: 16,
        textAlign: 'center',
        // color: theme.palette.text.secondary,
    },
});

const theme = createMuiTheme({
    palette: {
        primary: blueGrey,
        secondary: green,
    },
    status: {
        danger: 'orange',
    },
    typography: {
        display4: {
            fontWeight: 400,
            color: '#212121'
        }
    },
});

class App extends React.Component {

    constructor(props) {
        super(props);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        SubscriptionStore.listen(this.onChange);
    }

    componentWillUnmount() {
        SubscriptionStore.unlisten(this.onChange);
    }

    onChange(state) {
        this.setState(state);
    }

    handleClose() {
        this.setState({openDialog: false});
    }

    handleOpen() {
        this.setState({openDialog: true});
    }

    handleSubmit() {
        SubscriptionActions.addSubscription(this.email.value, this.name.value);
        this.setState({openDialog: false});
    }

    validateEmail() {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (this.email.value.length > 0) {
            this.setState({validEmail: re.test(this.email.value)});
        }
    }

    render() {
        return <MuiThemeProvider theme={theme}>
            <Reboot/>
            <div style={{
                height: '100%',
                backgroundImage: 'url(img/minecraft_brick.svg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center 50px'
            }} className={this.props.classes.root}>
                <Grid container spacing={0}>
                    <Grid item xs={6} sm={2}>
                    </Grid>
                    <Grid item xs={10} sm={8}>
                        <div style={{padding: '10px 0 0 0', color: 'dark-grey'}}>
                            <Typography variant="display4">Server Craft</Typography>
                        </div>
                        <Paper style={{
                            top: '50%',
                            left: '20%',
                            position: 'relative',
                            padding: '16px 16px 32px 16px',
                            width: '400px',
                            margin: 'auto 0'
                        }}>
                            <Typography variant="headline" component="h3">
                                Bestil din egen Minecraft server
                            </Typography>
                            <Typography component="p">
                                Her kan du k&oslash;be din egen private Minecraft server. Du kan spille p&aring; mobil
                                enhed og pc. Vi giver den f&oslash;rste m&aring;nede gratis.
                            </Typography>
                            <Button variant="fab"
                                    style={{float: 'right', position: 'relative', bottom: '-10px'}}
                                    onClick={this.handleOpen}><AddIcon/></Button>
                        </Paper>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                    </Grid>
                </Grid>
            </div>
            <Dialog
                open={this.state != null && this.state.openDialog === true}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Opret Minecraft server</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        For at oprette en server til dig har vi brug for nogle oplysninger fra dig.
                    </DialogContentText>
                    <TextField
                        inputRef={el => this.name = el}
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Navn"
                        type="text"
                        fullWidth
                    /> <TextField
                    onChange={this.validateEmail}
                    error={(this.state === null || this.state.validEmail === undefined ? false : !this.state.validEmail)}
                    inputRef={el => this.email = el}
                    margin="dense"
                    id="email"
                    label="Email"
                    type="email"
                    fullWidth
                />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Glem
                    </Button>
                    <Button onClick={this.handleSubmit} disabled={(this.state === null || this.state.validEmail === undefined || !this.state.validEmail)} color="primary">
                        Opret server
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={this.state != null && this.state.subscriptionConfirm === true}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Du er nu registreret</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Tak fordi du registrerede dig hos servercraft. Vi g&aring;r straks igang med at oprette din
                        server.
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </MuiThemeProvider>;
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

render(<App classes={styles()}/>, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.jsx